/* eslint-disable no-await-in-loop */
import { pdfjs } from 'react-pdf';

const readFileData = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target !== null) {
        resolve(e.target.result);
      }
      reject();
    };
    reader.onerror = (err) => {
      reject(err);
    };
    reader.readAsDataURL(file);
  });

const toBlobWrapper = (canvas) =>
  new Promise((resolve, reject) => {
    try {
      canvas.toBlob(resolve);
    } catch (error) {
      reject(error);
    }
  });

const createBlobPerPdfPage = async (file) => {
  const images = [];
  const data = await readFileData(file);
  const pdf = await pdfjs.getDocument(data).promise;
  const canvas = document.createElement('canvas');
  for (let i = 0; i < pdf.numPages; i += 1) {
    const page = await pdf.getPage(i + 1);
    const viewport = page.getViewport({ scale: 1.5 });
    const context = canvas.getContext('2d');
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    await page.render({ canvasContext: context, viewport }).promise;
    const imageBlob = await toBlobWrapper(canvas);
    images.push(imageBlob);
  }
  canvas.remove();
  return images;
};

const utils = { createBlobPerPdfPage };

export default utils;
